import { globalAPIDictionary } from "@core/global/global-country-dictionary";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { components } from "react-select";
import CreateReactSelect from "react-select/creatable";
import axios from "axios";
import { captureException } from "@sentry/react";
import { toast } from "react-toastify";
import { getSidebarCountData } from "@redux/Sidebar/sidebarCount.action";
import { useDispatch } from "react-redux";

export const AddToFavShipmentModal = ({ showFavModal, setShowFavModal, defaultData, identifier, customValue, bolType, tempViewShipmentObject, resetTempViewShipmentObject, setIsFavourite }) => {
  const [tags, setTags] = useState([]);
  const [tagList, setTagList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showFavModal) {
      let url = globalAPIDictionary.usersAllFavouriteCompanyTags + "?type=" + "shipments";
      if (identifier) {
        url += "&company_id=" + identifier;
      }
      axios
        .get(url)
        .then(({ data }) => {
          if (data.favouriteCompanyTags && data?.favouriteCompanyTags?.length) {
            let companyTags = data.favouriteCompanyTags.map((item) => ({ label: item, value: item }));
            let selectedTags = data.selectedTagList.map((item) => ({ label: item, value: item }));
            setTags(selectedTags);
            setTagList(companyTags);
          }
        })
        .catch((err) => {
          captureException(err);
        });
    }
  }, [showFavModal]);
  const onSubmitHandler = async () => {
    try {
      let payload = {
        company_id: identifier,
        data_source: tempViewShipmentObject ? (tempViewShipmentObject?.countryShortHand ? tempViewShipmentObject?.countryShortHand : tempViewShipmentObject.countryCaps.toLowerCase()) : defaultData.countryShortHand ? defaultData?.countryShortHand.toLowerCase() : defaultData.countryCaps.toLowerCase(),
        tags: tags?.length ? tags.map((tag) => tag.value) : [],
        trade_direction: tempViewShipmentObject?.countryType ? tempViewShipmentObject.countryType : defaultData.countryType,
        type: "shipments",
        redirectionKey: bolType,
        isAppendTags: true,
      };
      if (customValue) {
        payload.custom_value = customValue;
      }
      await axios.post(globalAPIDictionary.addFavouriteCompany, [payload]);
      setShowFavModal(false);
      dispatch(getSidebarCountData());
      setIsFavourite();
      toast.success("Shipment Bookmarked Successfully");
    } catch (err) {
      captureException(err);
      toast.error("Something went wrong!!!");
    } finally {
      setShowFavModal(false);
      resetTempViewShipmentObject();
    }
  };

  return (
    <div>
      {showFavModal ? (
        <Modal
          size="lg"
          centered
          show={showFavModal}
          onHide={() => {
            setShowFavModal(false);
            resetTempViewShipmentObject();
          }}>
          <Modal.Header closeButton>
            <Modal.Title>Add to Bookmarks</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="m-auto">
                <p className="add_to_fav_input_heading mb-1">Add customized tags for easy access in the Shipments Bookmark</p>
                <CreateReactSelect
                  options={tagList}
                  isMulti
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    NoOptionsMessage: (props) => (
                      <components.NoOptionsMessage {...props}>
                        <p className="text-left mb-0">Type to enter tags</p>
                      </components.NoOptionsMessage>
                    ),
                  }}
                  isOptionDisabled={() => tags && tags?.length >= 10}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      border: state.isFocused ? " 1px solid #6F08F1" : "",
                      "&:hover": {
                        border: "1px solid #6F08F1",
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 1000,
                    }),
                    multiValue: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "100px",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }),
                  }}
                  onChange={(e) => {
                    setTags(e);
                  }}
                  value={tags}
                  placeholder={"You can add upto 10 tags"}
                />
              </div>
              <div className="mt-4">
                <p className="add_to_fav_input_heading mb-0">Instructions:</p>
                <div>
                  <p className="m-0 mt-2">1. You can provide customized tags to filter down the list of your bookmark companies in the bookmarks section of your dashboard.</p>
                  <p className="m-0 mt-2">2. Some of the examples tags are: Product: Chemicals, Company Industry: Steel Manufacturing, etc.</p>
                </div>
              </div>{" "}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="fav-modal-cancel"
              variant="secondary"
              onClick={() => {
                setShowFavModal(false);
                resetTempViewShipmentObject();
              }}>
              Cancel
            </Button>
            <Button className="btn btn-primary trademo-new-btn" onClick={onSubmitHandler}>
              Add Tags
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <></>
      )}
    </div>
  );
};
